import React from 'react';
import { useSelector } from 'react-redux';
import StatisticsProvider from '../../StatisticsProvider';
import LineChartGrid from '../../../../components/stats/LineChartGrid';

export default function Google({ dateRangeFilter }) {
  const { company } = useSelector((state) => state.currentCompany);
  const { franchise } = company;

  return (
    <StatisticsProvider
      mainMetrics={['sales_from_google_seo', 'sales_from_google_business_profile']}
      googleBusinessMetrics={['google_business_impressions']}
      storefrontMetrics={
        franchise?.has_storefront
          ? [
              'website_visitors_from_google_business_profile',
              'website_visitors_from_google_ads',
              'website_visitors_from_google_seo',
            ]
          : []
      }
      googleAdsMetrics={[
        'google_ads_phone_calls',
        'google_ads_directions',
        'google_ads_impressions',
        'google_ads_clicks',
        'google_ads_absolute_top_impression_percentage',
        'google_ads_average_cpc',
        'google_ads_conversions_from_interactions_rate',
      ]}
      displayOrder={[
        'sales_from_google_seo',
        'website_visitors_from_google_seo',
        'sales_from_google_business_profile',
        'google_business_impressions',
        'website_visitors_from_google_business_profile',
        'google_ads_impressions',
        'google_ads_clicks',
        'google_ads_absolute_top_impression_percentage',
        'google_ads_average_cpc',
        'google_ads_conversions_from_interactions_rate',
        'google_ads_phone_calls',
        'google_ads_directions',
        'website_visitors_from_google_ads',
      ]}
      withInterval
      dateRangeFilter={dateRangeFilter}
    >
      <LineChartGrid />
    </StatisticsProvider>
  );
}
